// AnimatedText.js
import React from "react";
import '../styles/Textanimation.css';
import { useInView } from "react-intersection-observer";

// import styles from "../../styles/AnimatedText.module.css";
const AnimatedText3 = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // animate only once when it first comes into view
    threshold: 0.1,    // trigger when 10% of the component is in view
  });
  return (
    <div ref={ref} className={`container ${inView ? "animate" : ""}`}>
      <div className="text a"> Powerful </div>
      <div className="text b"> numbers </div>
      <div className="text c"> that  </div>
      <div className="text d"> tell </div>
      <div className="text e"> our </div>
      <div className="text f"> story </div>
    </div>
  );
};
export default AnimatedText3;